import { useEffect } from "react";
import { Button } from "@mui/material";
import { useMsal, useAccount } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

import Logo from "../../assets/img/fortiline-logo.png";
import { buildLoginRequest, shouldForceAccountPicker } from "../../auth/loginHelpers";
import { clearMsalCache } from "../../utils/clearMsalCache";

/**
 * Login page
 */
const Login = () => {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const navigate = useNavigate();
  const showAccountPickerHint = shouldForceAccountPicker();

  useEffect(() => {
    if (account) {
      navigate("/home", { replace: true });
    }
  }, [account, navigate]);

  if (inProgress !== "none") {
    return (
      <div className="pos-background">
        <div className="min-h-screen flex justify-center items-center">
          <p className="text-white text-lg font-semibold">Signing you in…</p>
        </div>
      </div>
    );
  }

  const login = async (forceAccountPicker: boolean) => {
    const stuckState = sessionStorage.getItem("msal.interaction.status");
    if (stuckState) {
      clearMsalCache();
    }
    try {
      await instance.loginRedirect(buildLoginRequest({ forceAccountPicker }));
    } catch (error) {
      console.error("MSAL: loginRedirect failed", error);
    }
  };

  return (
    <div className="pos-background">
      <div className="min-h-screen flex justify-center pb-6">
        <div className="h-full w-full mt-30 max-w-md rounded bg-white px-12 pb-6">
          <div className="flex flex-col justify-center items-center mt-12">
            <img src={Logo} alt="Reece" className="w-[150px]" />
            <p className="text-center text-lg text-reece-800 font-semibold mt-8">
              Waterworks Documentation Portal
            </p>
          </div>
          {showAccountPickerHint ? (
            <p className="text-sm text-amber-700 mt-6 text-center">
              That Microsoft account is not in this organization. Choose a
              Reece / Morsco work account.
            </p>
          ) : null}
          <div className="mt-48 mb-6">
            <Button
              className="bg-blue-950 cursor-pointer text-gray-100 p-3 w-full rounded tracking-wide font-semibold font-display focus:outline-none focus:shadow-outline hover:bg-gray-900 shadow-lg"
              onClick={() => login(false)}
              disabled={inProgress !== "none"}
            >
              Sign in with Microsoft
            </Button>
            <button
              type="button"
              className="mt-4 w-full text-sm text-reece-800 underline hover:no-underline"
              onClick={() => login(true)}
              disabled={inProgress !== "none"}
            >
              Use another account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
